module.exports = __webpack_public_path__ + "img/blogs_primary.8c3264a8.png";